import { PolicyCheckResult } from '../../model/entities/scoreModelEvaluation';
import { PolicyRule } from '../../model/interfaces/policyRule';
import { Result } from '../../pages/rules/modules/resultEnum';
import { EvaluatedRule } from './evaluatedRules';

export const ListEvaluatedResults = ({
  evaluations,
  result
}: {
  evaluations: PolicyCheckResult[] | PolicyRule[];
  result: Result;
}) => {
  return (
    <>
      {evaluations.map((evaluation, idx) => (
        <EvaluatedRule
          key={idx}
          id={evaluation.policyRuleId}
          name={evaluation.name}
          desc={evaluation.description}
          message={result !== Result.NOT_RUN ? evaluation.message : ''}
          result={result}
        />
      ))}
    </>
  );
};
